<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="首页商品管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">indexGoods</li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush" style="position: relative">
            <div class="card-body">
              <el-button type="primary" size="small" @click="openDialogFormCreate">添加</el-button>
              <el-select v-model="ruleForm.searchKey" placeholder="请选择" @change="changeSearchKey" style="margin-left: 20px">
                  <el-option label="基本业态(默认)" value="XYS:index_list" />
                  <el-option label="老人业态" value="XYS:index_list:old" />
              </el-select>
              <el-table border :data="data" style="margin-top: 20px">
                <el-table-column
                    prop="index"
                    label="位置"
                />
                <el-table-column
                    prop="skuId"
                    label="skuId"
                />
                <el-table-column
                    label="类型">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.isJd == 1" type="danger">京东</el-tag>
                    <el-tag v-if="scope.row.isJd == 2">自营</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="deleteGoods(scope.row)" type="danger">删除</el-button>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="添加首页商品" v-if="goodsDetailVisible" :visible.sync="goodsDetailVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="商品位置" prop="index">
          <el-input-number v-model.number="ruleForm.index"></el-input-number>
        </el-form-item>
        <el-form-item label="商品id" prop="skuId">
          <el-input v-model="ruleForm.skuId"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="isJd">
          <el-switch v-model="ruleForm.isJd" active-text="京东" active-value="1" inactive-value="2"
                     inactive-text="自营"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="goodsDetailVisible = false">取消</el-button>
        <el-button type="primary" @click="addGoods">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import {getAllIndexGoodsApi, removeByIndexApi, setIndexGoodsApi} from "@/api/goodsManageApi";

export default {
  name: 'indexGoods',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    // 这里存放数据
    return {
      data: [],
      goodsDetailVisible: false,
      ruleForm: {
        index: 1,
        skuId: "",
        isJd: 1,
        searchKey:"XYS:index_list"
      },
      rules: {
        index: [
          {required: true, message: '请输入商品位置', trigger: 'blur'}
        ],
        skuId: [
          {required: true, message: '请输入商品ID', trigger: 'blur'}
        ],
        isJd: [
          {required: true, message: '请选择类型', trigger: 'blur'}
        ],
      }

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    async getAllIndexGoods() {
      let {data} = await getAllIndexGoodsApi({searchKey:this.ruleForm.searchKey});
      this.data = data;
    },
    async deleteGoods(item){
      await removeByIndexApi({index:item.index,searchKey:this.ruleForm.searchKey})
      this.getAllIndexGoods()
      this.$message({
        message: '删除成功',
        type: 'success'
      });
    },
    openDialogFormCreate() {
      this.goodsDetailVisible = true
    },
     addGoods() {
      let tempSearchKey = this.ruleForm.searchKey
       this.$refs["ruleForm"].validate(async (valid) => {
         if (valid) {
           await setIndexGoodsApi(this.ruleForm)
           this.goodsDetailVisible = false
           this.ruleForm = {
             index: 1,
             skuId: "",
             isJd: 1,
             searchKey:tempSearchKey
           }
           this.getAllIndexGoods()
         }
       })
    },
    changeSearchKey(){
      this.getAllIndexGoods()
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getAllIndexGoods()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
//@import url(); 引入公共css类
</style>